import { CustomerSchema } from "@redotech/redo-model/customer";
import * as z from "zod/v4";

export const getCustomer = {
  name: "getCustomer" as const,
  input: z.object({ customerId: z.string() }),
  output: CustomerSchema,
};
